import React, { forwardRef } from 'react';
import DatePicker from "react-datepicker";
import { useTranslation } from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";

const DateInput = forwardRef((props, ref) => {
  const {
    dateFormat, isclearable, isClearable, minDate, maxDate, filterDate,
    selectsStart, selectsEnd, isOpen, isDisabled, onCalendarOpen,
    onCalendarClose, placeholdertext, ...inputProps
  } = props;

  return (
    <input
      placeholder={inputProps.placeholder || ''}
      {...inputProps}
      type="text"
      ref={ref}
      className='edit-input'
    />
  );
});

export const NGODatePicker = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const { placeholder, value, className, id, minDate, maxDate,filterDate,dateFormat,selectsStart,selectsEnd,required } = props;
  const isclearable = props?.isclearable !== undefined ? props.isclearable : true;
  const isOPen = props.isOpen !== undefined ? props.isOpen : false;
  const onCalendarOpen = typeof props.onCalendarOpen === 'function' ? props.onCalendarOpen : null;
  const onCalendarClose = typeof props.onCalendarClose === 'function' ? props.onCalendarClose : null;

  const parseSelectedDate = (val) => {
    if (!val) return null;
    if (val instanceof Date) return isNaN(val.getTime()) ? null : val;
    if (typeof val === 'string') {
      const parsed = new Date(val);
      return isNaN(parsed.getTime()) ? null : parsed;
    }
    return null;
  };
  const selectedDate = parseSelectedDate(value);

  const handleKeyDown = (e) => {
    if (!props.isClearable && (e.key === "Backspace" || e.key === "Delete")) {
      e.preventDefault();
    }
  }

  return (
    <div className={`date-input ${className || ''}`}>
    {onCalendarOpen&& onCalendarClose ?<DatePicker
        id={id ? id : ''}
         portalId="root"
         todayButton={t('today')} 
        isClearable={isclearable}
        selectsStart={selectsStart||false}
        selectsEnd={selectsEnd||false}
        isOpen={isOPen}
        onCalendarOpen={onCalendarOpen}
         onKeyDown={handleKeyDown}
        onCalendarClose={onCalendarClose}
        dateFormat={dateFormat||"dd/MM/yyyy"}
        selected={selectedDate}
        popperClassName="datepicker-popper-high"
        placeholderText={placeholder || t('datePickerPlaceholder')}
        customInput={<DateInput {...props} ref={ref} />}
        minDate={minDate}
        maxDate={maxDate}
        showYearDropdown
        yearDropdownItemNumber={100} // Number of years to show in dropdown
        scrollableYearDropdown
        filterDate={filterDate}
        disabled={props.isDisabled?props.isDisabled:props.disabled?props.disabled:false}
        required={required ? true : false}
        onChange={(_v) => {
          props.onChange && props.onChange({ target: { ...props, value: _v } });
        }}
      />:<DatePicker
        showYearDropdown
         portalId="root"
         todayButton={t('today')} 
        yearDropdownItemNumber={100} // Number of years to show in dropdown
        scrollableYearDropdown
        id={id ? id : ''}
        popperClassName="datepicker-popper-high"
        isClearable={isclearable}
        onKeyDown={handleKeyDown}
        selectsStart={selectsStart||false}
        selectsEnd={selectsEnd||false}
        dateFormat={dateFormat||"dd/MM/yyyy"}
        selected={selectedDate}
        disabled={props.isDisabled?props.isDisabled:props.disabled?props.disabled:false}
        placeholderText={placeholder || t('datePickerPlaceholder')}
        customInput={<DateInput {...props} ref={ref} />}
        minDate={minDate}
        maxDate={maxDate}
        required={required ? true : false}
        onChange={(_v) => {
          props.onChange && props.onChange({ target: { ...props, value: _v } });
        }}
      />}
    </div>
  );
});
